// extracted by mini-css-extract-plugin
export default {"bag":"Bag_bag__HRgJX","add":"Bag_add__9FLCm","star":"Bag_star__97r0J"};